import { render, staticRenderFns } from "./FinishView.vue?vue&type=template&id=2119c0fd&scoped=true"
import script from "./FinishView.vue?vue&type=script&lang=js"
export * from "./FinishView.vue?vue&type=script&lang=js"
import style0 from "./FinishView.vue?vue&type=style&index=0&id=2119c0fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119c0fd",
  null
  
)

export default component.exports